import { render, staticRenderFns } from "./settlement-form.vue?vue&type=template&id=82f0ad40&scoped=true&"
import script from "./settlement-form.vue?vue&type=script&lang=js&"
export * from "./settlement-form.vue?vue&type=script&lang=js&"
import style0 from "./settlement-form.vue?vue&type=style&index=0&id=82f0ad40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f0ad40",
  null
  
)

export default component.exports